import type { CallOutcome } from '../../lib/api';

/**
 * Die Ergebnisse eines Anrufs — eine Quelle für Knopf, Verlauf und Kundenakte.
 *
 * Warum nicht nur „erreicht ja/nein": Der Unterschied zwischen Mailbox, besetzt
 * und „niemand geht ran" entscheidet darüber, ob man es in fünf Minuten nochmal
 * versucht oder es für heute sein lässt. Wer das nicht unterscheiden kann,
 * schreibt am Ende gar nichts auf.
 */
export interface CallOutcomeMeta {
  value: CallOutcome;
  label: string;
  /** Kurzform für enge Stellen (Verlaufszeile, Badge). */
  short: string;
  color: string;
  /** Gilt das Gespräch als zustande gekommen? */
  reached: boolean;
}

export const CALL_OUTCOMES: CallOutcomeMeta[] = [
  { value: 'REACHED', label: 'Erreicht', short: 'erreicht', color: 'teal', reached: true },
  {
    value: 'CALLBACK_AGREED',
    label: 'Rückruf vereinbart',
    short: 'Rückruf vereinbart',
    color: 'blue',
    reached: true,
  },
  { value: 'NO_ANSWER', label: 'Niemand dran', short: 'nicht erreicht', color: 'orange', reached: false },
  { value: 'VOICEMAIL', label: 'Mailbox', short: 'Mailbox', color: 'grape', reached: false },
  { value: 'BUSY', label: 'Besetzt', short: 'besetzt', color: 'yellow', reached: false },
  {
    value: 'WRONG_NUMBER',
    label: 'Nummer falsch',
    short: 'Nummer falsch',
    color: 'red',
    reached: false,
  },
];

const BY_VALUE = new Map(CALL_OUTCOMES.map((o) => [o.value, o]));

export function callOutcomeMeta(outcome: CallOutcome): CallOutcomeMeta {
  return BY_VALUE.get(outcome) ?? CALL_OUTCOMES[0]!;
}

/** Sekunden als „3:07" — im Verlauf zählt die Länge, nicht die Genauigkeit. */
export function formatCallDuration(seconds: number | null | undefined): string | null {
  if (seconds == null || seconds <= 0) return null;
  const min = Math.floor(seconds / 60);
  const sec = seconds % 60;
  return `${min}:${String(sec).padStart(2, '0')}`;
}
